<template>
  <div class="">
    <section class="about-item-area">
      <div class="container">
        <div class="bg-white" v-loading="isLoading">
          <div class="divider mt-5 mb-15"></div>
          <EventInfo @event-ready="onEventReady" />
          <el-divider></el-divider>

          <!-- ========== 投稿通道已关闭 ========== -->
          <el-empty :description="$t('manuscript.channelClosed')"></el-empty>
          <!-- ========== 原投稿表单区域，已隐藏 ========== -->
          <template v-if="false">
            <!-- 通栏投稿须知 -->
            <div class="notice-section">
              <h4 class="notice-title">
                <svg width="18" height="18" viewBox="0 0 24 24" fill="#2978dd">
                  <path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm1 17h-2v-2h2v2zm0-4h-2V7h2v8z"/>
                </svg>
                {{ $t('manuscript.notice') }}
              </h4>

              <div class="notice-content-row">
                <div class="notice-col-left">
                  <p class="notice-subtitle">{{ $t('manuscript.topicTitle') }}</p>
                  <ul class="notice-list">
                    <li v-for="(item, idx) in $t('manuscript.topicList', { returnObjects: true })" :key="idx">
                      {{ item }}
                    </li>
                  </ul>
                </div>
                <div class="notice-col-right">
                  <p class="notice-subtitle">{{ $t('manuscript.formatTitle') }}</p>
                  <ul class="notice-list">
                    <li>{{ $t('manuscript.formatText') }}</li>
                  </ul>
                  <p class="notice-subtitle">{{ $t('manuscript.formatTime') }}</p>
                  <ul class="notice-list">
                    <li>{{ $t('manuscript.formatTimeTip') }}</li>
                  </ul>
                </div>
              </div>
            </div>

            <el-row :gutter="30">
              <el-col :span="10" :xs="24">
                <div class="upload-wrapper">
                  <div class="template-section">
                    <div class="template-item" @click="downloadPosterTemplate">
                      <div class="template-icon">
                        <svg width="36" height="36" viewBox="0 0 24 24" fill="#f39c12">
                          <path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z M14 2v6h6 M8 13h8 M8 17h8 M8 9h2"/>
                        </svg>
                      </div>
                      <div class="template-info">
                        <div class="template-name">ICEDM_2026_Abstract_Template</div>
                      </div>
                      <el-button type="primary" size="small">{{ $t('manuscript.download') }}</el-button>
                    </div>
                  </div>

                  <div class="file-upload-section">
                    <div class="file-upload-header">
                      <span class="file-upload-title">{{ $t('manuscript.uploadFile') }}</span>
                      <span class="file-upload-tip">{{ $t('manuscript.uploadFileTip') }}</span>
                    </div>
                    <div class="file-upload-box" @click="triggerFileInput">
                      <div v-if="posterFileList.length > 0" class="file-info">
                        <svg width="32" height="32" viewBox="0 0 24 24" fill="#e53e3e">
                          <path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z M14 2v6h6 M8 13h8 M8 17h8 M8 9h2"/>
                        </svg>
                        <span class="file-name">{{ posterFileList[0].name }}</span>
                        <span class="file-size">{{ formatFileSize(posterFileList[0].file?.size || 0) }}</span>
                        <div class="file-delete" @click.stop="handleDeletePosterFile">×</div>
                      </div>
                      <div v-else class="file-upload-placeholder">
                        <svg width="40" height="40" viewBox="0 0 24 24" fill="none" stroke="#94b8e8" stroke-width="1.5">
                          <path d="M12 5v14 M5 12h14"/>
                        </svg>
                        <span>{{ $t('manuscript.uploadFileAction') }}</span>
                      </div>
                      <input
                        ref="fileInputRef"
                        type="file"
                        accept=".pdf,.ppt,.pptx,.jpg,.jpeg"
                        class="hidden"
                        @change="handleFileSelect"
                      />
                    </div>
                    <div class="file-upload-tip">
                      <span class="text-red">*</span> {{ $t('manuscript.requiredTip') }}
                    </div>
                  </div>
                </div>
              </el-col>

              <el-col :span="14" :xs="24">
                <div class="form-wrapper">
                  <div class="form-title-bar">
                    <h4 class="form-title">{{ isEditMode ? ($t('manuscript.editTitle') || '编辑投稿') : ($t('manuscript.formTitle') || '投稿表单') }}</h4>
                  </div>

                  <el-form
                    ref="basicForm"
                    :model="form"
                    :rules="formRules"
                    :label-width="labelWidth"
                    class="poster-form"
                  >
                    <el-form-item :label="$t('manuscript.labelAuthorFirst')" prop="author.realname" required>
                      <el-input v-model="form.author.realname" :placeholder="$t('manuscript.placeholderAuthorFirst')" />
                    </el-form-item>

                    <el-form-item v-if="isEn" label="Country" prop="author.country" required>
                      <el-select v-model="form.author.country" placeholder="Please select country" filterable clearable style="width:100%">
                        <el-option v-for="(item, index) in countryOptions" :key="index" :label="item.name_en" :value="item.value" />
                      </el-select>
                    </el-form-item>

                    <el-form-item :label="$t('manuscript.labelPhone')" prop="author.cellphone" required>
                      <el-input v-model="form.author.cellphone" :placeholder="$t('manuscript.placeholderPhone')" />
                    </el-form-item>

                    <el-form-item :label="$t('manuscript.labelEmail')" prop="author.email" required>
                      <el-input v-model="form.author.email" :placeholder="$t('manuscript.placeholderEmail')" />
                    </el-form-item>

                    <el-form-item :label="$t('manuscript.labelPublishCompany')" prop="author.institution" required>
                      <el-input v-model="form.author.institution" :placeholder="$t('manuscript.placeholderPublishCompany')" />
                    </el-form-item>

                    <el-form-item :label="$t('manuscript.labelPosterTitle')" prop="title" required>
                      <el-input v-model="form.title" :placeholder="$t('manuscript.placeholderPosterTitle')" />
                    </el-form-item>

                    <el-form-item :label="$t('manuscript.labelAbstract')" prop="abstract" required>
                      <el-select v-model="form.abstract" :placeholder="$t('manuscript.placeholderAbstract')" filterable clearable style="width:100%">
                        <el-option v-for="(opt, idx) in $t('manuscript.topicList', { returnObjects: true })" :key="idx" :label="opt" :value="opt" />
                      </el-select>
                    </el-form-item>
                  </el-form>

                  <div class="form-actions mt-30 text-center">
                    <el-button type="primary" size="large" @click="submitForm" :loading="isSubmitting">
                      {{ isEditMode ? ($t('manuscript.updateBtn') || '更新投稿') : ($t('manuscript.submitBtn') || '提交投稿') }}
                    </el-button>
                    <el-button size="large" @click="resetForm">
                      {{ $t('register.reset') || '重置' }}
                    </el-button>
                    <el-button v-if="isEditMode" size="large" @click="goBack">
                      {{ $t('common.back') || '返回' }}
                    </el-button>
                  </div>
                </div>
              </el-col>
            </el-row>
          </template>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
import config from '@/config'
import EventInfo from "@/components/Event/Info.vue";
import { getManuscript, postManuscript, putManuscript } from "@/api/manuscripts";
import { getMeManuscriptFile, postMeManuscriptFile, offlineMeManuscriptFile, 
  // getMeOrders 
} from '@/api/user';
// import { getOrders } from '@/api/order';
import { formatTimestampToDate } from '@/utils/dateUtil';
import { eventBus } from '@/utils/eventBus.js';
import countryData from '@/components/Data/country.json';
import { getProfile } from "@/api/user";

export default {
  components: {
    EventInfo
  },
  inject: ['dataWrapper', 'fetchStatus'],
  data() {
    return {
      isLoading: false,
      isSubmitting: false,
      eventid: config.EVENTID,
      event: null,
      submissionId: null,
      submissionStatus: null,
      isEditMode: false,
      currentMid: null,
      countryOptions: countryData,
      userProfile: null,
      userProfileLoaded: false,
      form: {
        author: {
          realname: '',
          institution: '',
          department: '',
          cellphone: '',
          email: '',
          country: ''
        },
        title: '',
        summary: '',
        posterFile: null,
        abstract: '',
      },
      posterFileList: [],
      fileInputRef: null,
      hasExistingPoster: false,
      validOrders: [],
      hasRedirected: false,
      orderChecked: false,
      hasValidOrder: false,
    };
  },
  computed: {
    t() {
      return this.$t || this.$i18n?.t || ((key) => key)
    },
    isEn() {
      const locale = this.$i18n?.locale || localStorage.getItem('locale') || 'zh-cn';
      return locale === 'en' || locale === 'en-US';
    },
    labelWidth() {
      return this.isEn ? '180px' : '100px';
    },
    formRules() {
      const isEn = this.isEn;
      const rules = {
        'author.realname': [
          { required: true, message: isEn ? 'Please enter your full name' : '请输入姓名', trigger: 'blur' }
        ],
        'author.cellphone': [
          { required: true, message: isEn ? 'Please enter your phone number' : '请输入联系电话', trigger: 'blur' },
          { pattern: /^1[3-9]\d{9}$/, message: isEn ? 'Please enter a valid phone number' : '请输入正确的手机号码', trigger: 'blur' }
        ],
        'author.email': [
          { required: true, message: isEn ? 'Please enter your email' : '请输入电子邮箱', trigger: 'blur' },
          { pattern: /^\w+([.-]?\w+)*@\w+([.-]?\w+)*(\.\w{2,10})+$/, message: isEn ? 'Please enter a valid email address' : '请输入正确的邮箱格式', trigger: 'blur' }
        ],
        'author.institution': [
          { required: true, message: isEn ? 'Please enter your institution name' : '请输入单位名称', trigger: 'blur' }
        ],
        'title': [
          { required: true, message: isEn ? 'Please enter the poster title' : '请输入Poster题目', trigger: 'blur' }
        ],
        'abstract': [
          { required: true, message: isEn ? 'Please select the abstract' : '请选择征稿主题', trigger: 'blur' }
        ]
      };

      if (isEn) {
        rules['author.country'] = [
          { required: true, message: 'Please select country', trigger: 'change' }
        ];
      }

      return rules;
    },
    canSubmitManuscript() {
      return this.orderChecked && this.hasValidOrder;
    }
  },
  created() {
    const savedLocale = localStorage.getItem('locale');
    if (savedLocale) {
      this.currentLocale = savedLocale;
    } else if (this.$i18n?.locale) {
      this.currentLocale = this.$i18n.locale;
    }

    const id = this.$route.query.id;
    if (id) {
      this.isEditMode = true;
      this.submissionId = id;
    }

    eventBus.$on('event-ready', this.onEventReady);
    eventBus.$on('language-changed', (lang) => {
      this.currentLocale = lang;
    });

    if (this.$i18n && this.$i18n.on) {
      this.$i18n.on('languageChanged', (lang) => {
        this.currentLocale = lang;
      });
    }

    if (this.isEditMode) {
      this.loadManuscript(this.submissionId);
    }
    this.loadUserProfile();
  },
  beforeDestroy() {
    if (this.$i18n && this.$i18n.off) {
      this.$i18n.off('languageChanged');
    }
    eventBus.$off('event-ready', this.onEventReady);
    eventBus.$off('language-changed');
  },
  methods: {
    formatTimestampToDate,

    formatFileSize(bytes) {
      if (bytes < 1024) return bytes + 'B';
      if (bytes < 1024 * 1024) return (bytes / 1024).toFixed(1) + 'KB';
      return (bytes / 1024 / 1024).toFixed(1) + 'MB';
    },

    getErrorMessage(key, fallback) {
      if (this.isEn) {
        return this.$t(`manuscript.errors.${key}`) || fallback;
      }
      return fallback;
    },

    goBack() {
      this.$router.push('/manuscript/result')
    },

    buildSubmitData() {
      const data = {
        eventid: this.eventid,
        author: {
          realname: this.form.author.realname || '',
          institution: this.form.author.institution || '',
          department: this.form.author.department || '',
          country: this.form.author.country || '',
          cellphone: this.form.author.cellphone || '',
          email: this.form.author.email || ''
        },
        title: this.form.title || '',
        summary: this.form.summary || '',
        abstract: this.form.abstract || '',
        meta: {
          submitTime: new Date().toISOString(),
          locale: this.currentLocale,
        }
      };

      if (this.isEn && this.form.author.country) {
        data.author.country = this.form.author.country;
      }
      console.log('提交数据:', data);
      return data;
    },

    async loadManuscript(id) {
      this.isLoading = true;
      try {
        const response = await getManuscript(this.eventid, id);
        if (response.code < 300 && response.data) {
          const data = response.data;
          this.currentMid = data.id;
          this.submissionId = data.id;

          if (data.author) {
            this.form.author.realname = data.author.realname || '';
            this.form.author.institution = data.author.institution || '';
            this.form.author.department = data.author.department || '';
            this.form.author.cellphone = data.author.cellphone || '';
            this.form.author.email = data.author.email || '';
            this.form.author.country = data.author.country || '';
            this.form.abstract = data.abstract || '';
          }
          if (data.title) {
            this.form.title = data.title;
          }
          if (data.summary) {
            this.form.summary = data.summary;
          }

          await this.loadFiles(this.currentMid);
          return data;
        }
        return null;
      } catch (error) {
        console.error('加载投稿数据失败:', error);
        const msg = this.isEn ? 'Failed to load submission data, please refresh and try again' : '加载投稿数据失败，请刷新重试';
        this.$message.error(msg);
        return null;
      } finally {
        this.isLoading = false;
      }
    },

    async loadFiles(mid) {
      try {
        const res = await getMeManuscriptFile(mid, { filter: { status: 100 } });
        if (res.code !== 200 || !Array.isArray(res.list)) return;

        const posterItem = res.list.find(item => item.meta?.type === 2);
        if (posterItem) {
          this.posterFileList = [{
            fileurl: posterItem.fileurl,
            name: posterItem.name || 'File',
            id: posterItem.id,
            isExisting: true
          }];
          this.hasExistingPoster = true;
        } else {
          this.posterFileList = [];
          this.hasExistingPoster = false;
        }
      } catch (error) {
        console.error('加载附件失败:', error);
      }
    },

    triggerFileInput() {
      this.$refs.fileInputRef?.click();
    },

    handleFileSelect(e) {
      const file = e.target.files?.[0];
      if (!file) return;

      const allowExts = ['.pdf', '.ppt', '.pptx', '.jpg', '.jpeg'];
      const isAllow = allowExts.some(ext => file.name.toLowerCase().endsWith(ext));
      if (!isAllow) {
        const msg = this.isEn ? 'Only PDF, PPT, JPG formats are supported' : '仅支持 PDF、PPT、JPG 格式';
        this.$message.error(msg);
        return;
      }
      if (file.size > 20 * 1024 * 1024) {
        const msg = this.isEn ? 'File size cannot exceed 20MB' : '文件大小不能超过 20MB';
        this.$message.error(msg);
        return;
      }

      const previewUrl = URL.createObjectURL(file);
      this.posterFileList = [{
        file,
        fileurl: previewUrl,
        name: file.name,
        isExisting: false
      }];
      this.form.posterFile = file;
      this.hasExistingPoster = false;
    },

    async handleDeletePosterFile() {
      if (this.posterFileList[0]?.id && this.currentMid) {
        try {
          await offlineMeManuscriptFile(this.currentMid, this.posterFileList[0].id);
        } catch (error) {
          console.error('删除海报失败:', error);
        }
      }
      this.posterFileList = [];
      this.form.posterFile = null;
      this.hasExistingPoster = false;
    },

    async uploadPosterFile(mid, file) {
      try {
        const res = await postMeManuscriptFile(mid, file, {
          status: 100,
          meta: { type: 2 }
        });
        if (res.code === 201) {
          return res.data;
        } else {
          throw new Error(res.msg || 'Upload failed');
        }
      } catch (error) {
        console.error('上传海报文件失败:', error);
        throw error;
      }
    },

    downloadPosterTemplate() {
      const a = document.createElement('a');
      a.href = '/ICEDM_2026_Abstract_Template.docx';
      a.download = 'ICEDM_2026_Abstract_Template.docx';
      document.body.appendChild(a);
      a.click();
      document.body.removeChild(a);
    },

    onEventReady(eventData) {
      this.event = eventData;
      this.isLoading = false;
      // this.loadAllValidOrders();  // 注释掉判断注册的部分
    },

    async submitForm() {
      let validAll = true;
      if (this.$refs.basicForm) {
        try {
          await this.$refs.basicForm.validate();
        } catch (error) {
          validAll = false;
        }
      }

      if (!validAll) {
        const msg = this.isEn ? 'Please complete all submission information' : '请完善投稿信息';
        this.$message.error(msg);
        return;
      }

      const hasPoster = this.posterFileList.length > 0;

      if (!this.isEditMode) {
        if (!hasPoster) {
          const msg = this.isEn ? 'Please upload your submission file' : '请上传投稿文件';
          this.$message.warning(msg);
          return;
        }
      } else {
        if (!hasPoster && !this.hasExistingPoster) {
          const msg = this.isEn ? 'Please upload your submission file' : '请上传投稿文件';
          this.$message.warning(msg);
          return;
        }
      }

      this.isSubmitting = true;

      try {
        const submitData = this.buildSubmitData();
        let response;
        if (this.isEditMode && this.submissionId) {
          response = await putManuscript(this.eventid, this.submissionId, submitData);

          if (response.code < 300) {
            const mid = this.submissionId;
            if (this.form.posterFile && this.posterFileList.length > 0 && !this.posterFileList[0]?.isExisting) {
              await this.uploadPosterFile(mid, this.form.posterFile);
            }
          }
        } else {
          response = await postManuscript(this.eventid, submitData);

          if (response.code < 300 && response.data && response.data.id) {
            const mid = response.data.id;
            this.currentMid = mid;
            this.submissionId = mid;

            if (this.form.posterFile) {
              await this.uploadPosterFile(mid, this.form.posterFile);
            }
          }
        }

        if (response.code < 300) {
          const successMsg = this.isEditMode
            ? (this.isEn ? 'Submission updated successfully!' : '投稿更新成功！')
            : (this.isEn ? 'Submission successful!' : '投稿成功！');
          this.$message.success(successMsg);

          this.$emit('submit-success', response.data);

          setTimeout(() => {
            this.$router.push('/manuscript/result');
          }, 1500);

        } else {
          const errMsg = this.isEn ? 'Submission failed, please try again' : '投稿失败，请稍后重试';
          throw new Error(response.msg || errMsg);
        }

      } catch (error) {
        console.error('提交失败:', error);
        const errMsg = this.isEn ? 'Submission failed, please try again' : '提交失败，请稍后重试';
        this.$message.error(error.message || errMsg);
      } finally {
        this.isSubmitting = false;
      }
    },

    resetForm() {
      if (this.isEditMode && this.submissionId) {
        this.loadManuscript(this.submissionId);
        return;
      }

      if (this.$refs.basicForm) {
        this.$refs.basicForm.resetFields();
      }

      this.form.author = {
        realname: '',
        institution: '',
        department: '',
        cellphone: '',
        email: '',
        country: ''
      };
      this.form.title = '';
      this.form.abstract = '';
      this.form.summary = '';
      this.form.posterFile = null;
      this.posterFileList = [];
      this.hasExistingPoster = false;

      this.$nextTick(() => {
        if (this.$refs.basicForm) {
          this.$refs.basicForm.clearValidate();
        }
      });

      const msg = this.isEn ? 'Form has been reset' : '已重置表单';
      this.$message.success(msg);
    },

    // async loadAllValidOrders() { ... }  // 已注释掉
    // async queryOrdersByCurrentUser() { ... }  // 已注释掉
    // getCurrentUserCellphone() { ... }  // 已注释掉
    // filterValidOrders(list) { ... }  // 已注释掉
    // handleNoValidOrder() { ... }  // 已注释掉
    // goToRegister() { ... }  // 已注释掉

    async loadUserProfile() {
      try {
        const res = await getProfile();
        if (res && res.code < 300 && res.data) {
          this.userProfile = res.data;
        } else {
          this.userProfile = null;
        }
      } catch (error) {
        console.error('获取用户信息失败:', error);
        this.userProfile = null;
      } finally {
        this.userProfileLoaded = true;
      }
    },
  }
};
</script>

<style scoped>
/* 隐藏 input */
.hidden {
  display: none;
}

.pc-padding {
  padding-left: 150px;
  padding-right: 150px;
}

@media (max-width: 768px) {
  .pc-padding {
    padding-left: 20px;
    padding-right: 20px;
  }
}

/* ===== 上传区域 ===== */
.upload-wrapper {
  padding-right: 20px;
}

/* 投稿须知 */
.notice-section {
  background: #f0f7ff;
  border: 1px solid #c2d8f8;
  border-radius: 12px;
  padding: 14px 18px;
  margin-bottom: 20px;
}

.notice-title {
  display: flex;
  align-items: center;
  gap: 8px;
  font-size: 15px;
  font-weight: 600;
  color: #2978dd;
  margin: 0 0 8px 0;
}

.notice-content-row {
  display: flex;
  flex-wrap: wrap;
  gap: 32px;
}

.notice-col-left {
  flex: 1 1 420px;
}
.notice-col-right {
  flex: 1 1 320px;
}

.notice-subtitle {
  font-weight: 600;
  font-size: 14px;
  margin: 4px 0 2px;
}

.notice-list {
  list-style: none;
  padding: 0;
  margin: 0;
  display: flex;
  flex-direction: column;
  gap: 2px;
}

.notice-list li {
  padding: 2px 0;
  color: #555;
  font-size: 13px;
  line-height: 1.1;
  display: flex;
  gap: 8px;
}

.notice-list li::before {
  content: '•';
  color: #2978dd;
  font-weight: bold;
}

/* 下载模板 */
.template-section {
  display: flex;
  flex-direction: column;
  gap: 10px;
  margin-bottom: 16px;
}

.template-item {
  display: flex;
  align-items: center;
  gap: 14px;
  padding: 12px 16px;
  background: #fff;
  border: 1px solid #e5e7eb;
  border-radius: 10px;
  cursor: pointer;
  transition: all 0.3s ease;
}

.template-item:hover {
  border-color: #2978dd;
  box-shadow: 0 2px 8px rgba(41, 120, 221, 0.1);
}

.template-icon {
  flex-shrink: 0;
}

.template-info {
  flex: 1;
}

.template-name {
  font-size: 14px;
  font-weight: 500;
  color: #333;
}

.template-size {
  font-size: 12px;
  color: #999;
}

/* 文件上传 */
.file-upload-section {
  background: #f8fafc;
  border-radius: 12px;
  padding: 16px 20px;
  border: 1px solid #e8ecf1;
}

.file-upload-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 12px;
}

.file-upload-title {
  font-size: 15px;
  font-weight: 600;
  color: #1a3a6b;
}

.file-upload-tip {
  font-size: 12px;
  color: #999;
}

.file-upload-box {
  border: 2px dashed #c2d8f8;
  border-radius: 10px;
  padding: 20px;
  text-align: center;
  cursor: pointer;
  transition: all 0.3s ease;
  background: #fff;
  min-height: 120px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.file-upload-box:hover {
  border-color: #2978dd;
  background: #f0f7ff;
}

.file-upload-placeholder {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 8px;
  color: #94b8e8;
}

.file-info {
  display: flex;
  align-items: center;
  gap: 12px;
  justify-content: center;
  width: 100%;
}

.file-name {
  font-size: 14px;
  color: #333;
  flex: 1;
}

.file-size {
  font-size: 12px;
  color: #999;
}

.file-delete {
  width: 22px;
  height: 22px;
  background: #f56c6c;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #fff;
  cursor: pointer;
  font-size: 14px;
  flex-shrink: 0;
}

.file-delete:hover {
  background: #e53e3e;
}

.file-upload-tip {
  margin-top: 8px;
  font-size: 13px;
  color: #666;
}

.text-red {
  color: #f56c6c;
}

/* ===== 表单样式 ===== */
.form-wrapper {
  padding-left: 20px;
}

.form-title-bar {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 24px;
  padding-bottom: 12px;
  border-bottom: 2px solid #f0f4f8;
}

.form-title {
  font-size: 18px;
  font-weight: 600;
  color: #1a3a6b;
  margin: 0;
}

.form-subtitle {
  font-size: 14px;
  color: #999;
}

.form-actions {
  margin-top: 30px;
  padding-top: 20px;
  border-top: 1px solid #f0f4f8;
}

/* ===== 响应式 ===== */
@media (max-width: 768px) {
  .upload-wrapper {
    padding-right: 0;
  }

  .form-wrapper {
    padding-left: 0;
    margin-top: 20px;
  }

  .template-item {
    flex-wrap: wrap;
  }
}
</style>